import React, { Route, Navigate } from 'react-router-dom';
import RepeatReferralDetails from '../../pages/sales/repeat-referral-details';
import Sales from '../../pages/sales';
import AllSales from '../../pages/sales/all/all-sales-container';
import Invoice from '../../pages/sales/invoices/invoice-container';
import PartnerInvoice from '../../pages/sales/partner-invoice';
import SalesRecording from '../../pages/sales/sales-recording';

const useSalesRoutes = () => (
  <Route path="sales" element={<Sales />}>
    <Route index element={<Navigate to="/sales/all" />} handle={{ tab: '/all' }} />
    <Route path="all" element={<AllSales />} handle={{ tab: '/all' }} />
    <Route path="repeat-referral/:repeatReferralId" element={<RepeatReferralDetails />} handle={{ tab: '/all' }} />
    <Route path="invoices" element={<Invoice />} handle={{ tab: '/invoices' }} />
    <Route path="invoices/:partnerId" element={<PartnerInvoice />} handle={{ tab: '/invoices' }} />
    <Route path="invoices/:partnerId/:salesRecordingId" element={<SalesRecording />} handle={{ tab: '/invoices' }} />
  </Route>
);

export default useSalesRoutes;
